// Design tokens for the Ask AI surface — Claude.ai inspired minimal palette.
// Keep these in one place so the visual language is consistent across the
// new subcomponents.

export const askAiTokens = {
  color: {
    surface: "#ffffff",
    surfaceMuted: "#fafaf9",
    surfaceHover: "#f5f5f4",
    border: "#ececec",
    borderStrong: "#dcdcdc",
    text: "#1a1a1a",
    textMuted: "#6b7280",
    textSubtle: "#9ca3af",
    accent: "#2263b3",
    accentSoft: "#eff4fb",
    success: "#16a34a",
    danger: "#dc2626",
    warning: "#d97706",
  },
  radius: {
    sm: 8,
    md: 12,
    lg: 16,
    pill: 999,
  },
  space: {
    s1: 4,
    s2: 8,
    s3: 12,
    s4: 16,
    s5: 20,
    s6: 24,
    s8: 32,
    s10: 40,
  },
  font: {
    sans: '"Inter", ui-sans-serif, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    serif:
      '"Instrument Serif", "Iowan Old Style", "Apple Garamond", "Palatino Linotype", "Times New Roman", Georgia, serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace',
    size: {
      xs: 11,
      sm: 12,
      base: 14,
      md: 15,
      lg: 17,
      xl: 22,
      // Conversation body text — used by user + assistant message turns.
      // Bumped above `base` so the actual content reads larger than chrome.
      message: 16,
    },
  },
  layout: {
    // Wider than a typical chat reading column so tables, long bullet
    // lists, and side-by-side data have room to breathe.
    contentMaxWidth: 960,
    inputMaxWidth: 980,
    sidePanelWidth: 320,
  },
} as const;

export type AskAiTokens = typeof askAiTokens;
